import styled from 'styled-components';

export const AdminStoreOrdersContainer = styled.div`
  padding: 20px;
`;

export const TotalPriceTd = styled.td`
  text-align: right;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0px;
  cursor: pointer;
`;
export const CheckBoxLabel = styled.span`
  padding-left: 5px;
`;
